const RETURN_TO_KEY = "sa.auth.returnTo";

/** A same-site path: starts with one slash, never `//host` or `/\\host` (which browsers read as a host). */
export const isLocalPath = (path: string | null): path is string =>
	Boolean(path?.startsWith("/") && !path.startsWith("//") && !path.startsWith("/\\"));

/**
 * Remembers the page someone was on (path and query, e.g. an emailed Review link with `?org=`) when
 * they leave for DXM SSO, so the sign-in callback can bring them back to it instead of home.
 */
export const rememberReturnTo = (path: string) => {
	if (!isLocalPath(path)) return;
	try {
		sessionStorage.setItem(RETURN_TO_KEY, path);
	} catch {
		// Storage can be unavailable (private mode); sign-in then lands on the home page.
	}
};

/** The remembered page, once (it is cleared), or `fallback` when there is none or it is not local. */
export const takeReturnTo = (fallback: string): string => {
	try {
		const path = sessionStorage.getItem(RETURN_TO_KEY);
		sessionStorage.removeItem(RETURN_TO_KEY);
		return isLocalPath(path) ? path : fallback;
	} catch {
		return fallback;
	}
};

/** The page someone is on now, to come back to after sign-in; none on the home page. */
export const currentReturnTo = (): string | undefined => {
	const path = `${window.location.pathname}${window.location.search}`;
	return path === "/" ? undefined : path;
};
